import React, { useMemo } from 'react';
import classnames from 'classnames';
import { isValidNumber } from '@gp/utils/common';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IPercentProgressData {
  width: string;
  percentage: string;
  percentageNum: number;
}

interface IPercentProgressProps extends IBaseProps {
  percent: string;
}

const PercentProgress: React.FC<IPercentProgressProps> = (props) => {
  const { style, className, percent = '0' } = props;

  // 目前都是保留整数
  const { width, percentage, percentageNum } = useMemo<IPercentProgressData>(() => {
    if (!percent || percent === '0') return { width: '0%', percentage: '0%', percentageNum: 0 };

    let res = '0';
    if (percent?.includes('%')) {
      const percentV = percent?.slice(0, -1);
      const resPercentV = isValidNumber(percentV) ? Math?.round(Number(percentV)) : '0';
      res = String(resPercentV);
    } else {
      res = isValidNumber(percent) ? String(Math?.round(Number(percent) * 100)) : '0';
    }

    // 负数
    if (res?.includes('-')) {
      res = res?.replaceAll('-', '');
    }

    const resLen = res?.length || 0;
    const isMax = resLen > 3;
    const resNum = Number(res);

    return {
      // 100%进度条撑满
      width: resNum > 100 ? '100%' : `${resNum}%`,
      // 最大百分比进度条撑满，其余按 当前百分比/最大百分比 计算进度条的百分比
      // width: isMax ? '100%' : `${(resNum / 999) * 100}%`,
      percentage: isMax ? '999%' : `${resNum}%`,
      percentageNum: resNum,
    };
  }, [percent]);

  return (
    <section style={style} className={classnames('gp-general-percent-progress', className)}>
      <aside className="gp-percent-progress-left">
        <i
          style={{ width }}
          className={classnames('gp-percent-progress-left-progress', {
            'gp-percent-progress-left-progress--overmax': percentageNum && percentageNum >= 100,
          })}
        ></i>
      </aside>
      <article className="gp-percent-progress-right">{percentage}</article>
    </section>
  );
};

export default React.memo(PercentProgress);
